import type { SeasonalThemeDefinition, SeasonalThemeName } from '../SeasonalTheme';
import { originalTheme } from './original';
import { autumnTheme } from './autumn';
import { christmasTheme } from './christmas';

/** Register every theme here. The key must match `SeasonalThemeName`. */
export const SEASONAL_THEMES: Record<SeasonalThemeName, SeasonalThemeDefinition> = {
  original: originalTheme,
  autumn: autumnTheme,
  christmas: christmasTheme,
};
